// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1JUJn"};